import React from "react";
import "./product_sstyle.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "aos/dist/aos.css";
import "react-medium-image-zoom/dist/styles.css";

import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import banner from "../img/logo/banner-bg.png";
import bottom from "../img/logo/left_bottom.png";

import moes from "../img/supports/moes.svg";
import iic from "../img/supports/iic.svg";
import aicte from "../img/supports/aicte.svg";
import big_f from "../img/supports/big_foundation.svg";
import igs from "../img/supports/igs.svg";
import link_shape from "../img/supports/link_shape.png";

function Supports() {
  return (
    <section id="Support" className="home-bg-in gap">
      <img src={bottom} alt="banner" className="bottomdesign" width="20%" />
      <Container >
        <h1 className="dark-heading">Support Network</h1>
        <p className="para-text">
          <b>ABLEPRO SOLUTIONS</b> is grateful to have these players
          supporting us in our mission to enable, engage, and empower our
          communities.
        </p>

        <Row>
        <Col xs={12} sm={12} md={4} lg={4}>
            <div className="our_team_cont">
            <div className="mobile-center">
              <img src={aicte} alt="AICTE" width="25%" /><br /><br />
              </div>
              <p className="para-text">
              <span className="para-text-high">All India Council for Technical Education (AICTE)</span>: <br />
                A national-level apex advisory body governing all technical institutes’ educational development in India.
                <br />
                <a
                  href="https://www.aicte-india.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  AICTE <img src={link_shape} alt="link" />
                </a>
              </p>
            </div>
          </Col>
          
          <Col xs={12} sm={12} md={4} lg={4}>
            <div className="our_team_cont">
              <div className="mobile-center">
              <img src={moes} alt="MoE's Innovation Cell" width="80%" /><br /><br />
              </div>
              <p className="para-text">
              <span className="para-text-high">MIC</span>: <br />
                To contribute effectively to innovation landscape of India by establishing sustainable ecosystem for fostering the culture of innovation and entrepreneurship across the Education sector.
                <br />
                <a
                  href="https://mic.gov.in/"
                  target="_blank"
                  rel="noreferrer"
                >
                  MoE's Innovation Cell <img src={link_shape} alt="link" />
                </a>
              </p>
            </div>
          </Col>

          <Col xs={12} sm={12} md={4} lg={4} >
            <div className="our_team_cont">
            <div className="mobile-center">
              <img src={iic} alt="MHRD's IIC" width="55%" /><br /><br />
              </div>
              <p className="para-text">
              <span className="para-text-high">IIC</span>: <br />
                An Initiative of the Ministry of Human Resource Development (MHRD), Govt. of India for selected Higher Education Institutes.
                <br />
                <a
                  href="https://iic.mic.gov.in/"
                  target="_blank"
                  rel="noreferrer"
                >
                  MHRD's IIC <img src={link_shape} alt="link" />
                </a>
              </p>
            </div>
          </Col>

          

          <Col xs={12} sm={12} md={4} lg={4}>
            <div className="our_team_cont">
            <div className="mobile-center">
              <img src={big_f} alt="BIG Foundation" width="25%" /><br /><br />
              </div>
              <p className="para-text">
              <span className="para-text-high">BM Sreenivasaiah Innovator’s Guild Foundation</span>: <br />
              Encourage entrepreneurship by supporting innovation and transferring technology for commercial use through diverse approaches.
                <br />
                <a
                  href="https://bmsce.ac.in/home/About-Big-Foundation"
                  target="_blank"
                  rel="noreferrer"
                >
                  BIG Foundation <img src={link_shape} alt="link" />
                </a>
              </p>
            </div>
          </Col>

          <Col xs={12} sm={12} md={3} lg={3} >
            <div className="our_team_cont">
            <div className="mobile-center">
              <img src={igs} alt="AICTE" width="35%" /><br /><br />
              </div>
              <p className="para-text">
              <span className="para-text-high">Intact Green Services</span>: <br />
                Trusted technology partner – Provider of digital engineering solutions.
                <br />
                <a
                  href="https://www.igsglobal.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  IGS Global <img src={link_shape} alt="link" />
                </a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Supports; 